import React from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row, Glyphicon } from 'react-bootstrap';
import StatusIndicators from './StatusIndicators';
//import indicator from './logo.svg';

const url = '<iframe width="430" height="260" style="border: 1px solid #cccccc;" src="https://thingspeak.com/channels/1033382/charts/[[ID]]?bgcolor=%23ffffff&color=%23d62020&dynamic=true&results=60&title=[[TITLE]]&type=line"></iframe>';
//const url2 = '<iframe width="430" height="100" style="border: 0px solid #cccccc;" src="/assets/status.html"></iframe>';
const Home = props => (
    <div>
        <h1 className="fontcolor">Clima Control Station project</h1>
        {/*
    <p>Welcome to your new single-page application, built with:</p>
    <ul>
      <li><a href='https://get.asp.net/'>ASP.NET Core</a> and <a href='https://msdn.microsoft.com/en-us/library/67ef8sbd.aspx'>C#</a> for cross-platform server-side code</li>
      <li><a href='https://facebook.github.io/react/'>React</a> and <a href='https://redux.js.org/'>Redux</a> for client-side code</li>
      <li><a href='http://getbootstrap.com/'>Bootstrap</a> for layout and styling</li>
    </ul>
    <p>To help you get started, we've also set up:</p>
    <ul>
      <li><strong>Client-side navigation</strong>. For example, click <em>Counter</em> then <em>Back</em> to return here.</li>
      <li><strong>Development server integration</strong>. In development mode, the development server from <code>create-react-app</code> runs in the background automatically, so your client-side resources are dynamically built on demand and the page refreshes when you modify any file.</li>
      <li><strong>Efficient production builds</strong>. In production mode, development-time features are disabled, and your <code>dotnet publish</code> configuration produces minified, efficiently bundled JavaScript files.</li>
    </ul>
    <p>The <code>ClientApp</code> subdirectory is a standard React application based on the <code>create-react-app</code> template. If you open a command prompt in that directory, you can run <code>npm</code> commands such as <code>npm test</code> or <code>npm install</code>.</p>
        */}


        <Grid fluid>
            <StatusIndicators />
            <Row>
                <Col lg={6} className="spacer">
                    <Iframe iframe={url.replace('[[ID]]', '1').replace('[[TITLE]]', 'Temperature+%28%2AC%29')} />
                </Col>
                <Col lg={6} className="spacer">
                    <Iframe iframe={url.replace('[[ID]]', '2').replace('[[TITLE]]', 'Humidity+%28RH%25%29')} />
                </Col>
            </Row>
            <Row>
                <Col lg={6} className="spacer">
                    <Iframe iframe={url.replace('[[ID]]', '4').replace('[[TITLE]]', 'Illuminance+%28Lux%29')} />
                </Col>
                <Col lg={6} className="spacer">
                    <Iframe iframe={url.replace('[[ID]]', '5').replace('[[TITLE]]', 'Dust+Density+%28%CE%BCgr%2Fm3%29')} />
                </Col>
            </Row>
            <Row>
                <Col lg={6} className="spacer">
                    <Iframe iframe={url.replace('[[ID]]', '3').replace('[[TITLE]]', 'Pressure+%28hPA%29')} />
                </Col>
                <Col lg={6} className="spacer">
                    <Iframe iframe={url.replace('[[ID]]', '6').replace('[[TITLE]]', 'CO2+%28PPM%29')} />
                </Col>
            </Row>
        </Grid>
    </div>
);


function Iframe(props) {
    return (
        <div
            dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
        />
    );
}

export default connect()(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js